// Stage 34c — toast() lazy wrapper.
//
// cos-toast was statically imported by 7 components, pinning it to
// the entry bundle even though app.ts dynamic-imports it for the
// guard-redirect paths (Vite emitted a warning for ~10 stages
// because of the mixed mode). Routing every caller through this
// helper collapses the static-import sites; cos-toast ships as a
// ~1-1.5 kB lazy chunk that loads the first time something calls
// showToast.
//
// First call has a ~10-50ms one-off cost while the chunk lands.
// Toast UX is "fire-and-forget feedback" — nobody waits on the
// promise — so we don't `await` and the call sites stay one-liners.
// Subsequent calls hit the cached chunk and are instant.
//
// Signature mirrors components/cos-toast.ts → toast(...) so a
// future contributor can swap import paths without changing call
// shapes.

// success/warning/danger/info are the five-meaning words (1 Nov 2026); ok/warn/error are aliases.
export type ToastKind = "success" | "warning" | "danger" | "info" | "warn" | "ok" | "error";

// showToast lazy-loads cos-toast and forwards the args. Returns
// the underlying promise for tests that want to await; production
// call sites discard it.
export function showToast(
	message: string,
	kind: ToastKind = "info",
	durationMs?: number,
	link?: { label: string; href: string },
): Promise<void> {
	return import("../components/cos-toast.js").then(({ toast }) => {
		toast(message, kind, durationMs, link);
	});
}
